import type { PageCard } from '@/play/pageTypes'
import { ClayCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'clay',
  number: 16,
  title: 'Clay',
  question: 'Does pressing on lumps and coils of clay, and carving them, feel like modelling clay?',
  status: 'open',
  accent: '#e7c2a8',
  CardArt: ClayCardArt,
}
